import { clamp } from "./auth-service-tools564.js";

function levelToNumber(level, fallback) {
  if (!level) {
    return fallback || 0;
  }

  return level === "month" ? 0 : level === "year" ? 1 : 2;
}

function levelNumberToLevel(levelNumber) {
  return levelNumber === 0 ? "month" : levelNumber === 1 ? "year" : "decade";
}

function clampLevel(level, minLevel, maxLevel) {
  return levelNumberToLevel(clamp(levelToNumber(level, 0), levelToNumber(minLevel, 0), levelToNumber(maxLevel, 2)));
}

export { clampLevel };